import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { useIdleTimer } from 'react-idle-timer';
import { container } from 'tsyringe';

export function IdleTimer() {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const timeout = 5000;

  const handleOnActive = () => {
    playersOnlineRepository.onPlayerAwayChanged(false);
  };
  const handleOnIdle = () => {
    playersOnlineRepository.onPlayerAwayChanged(true);
  };

  useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  return null;
}
